import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout, { loader as layoutLoader } from "./routes/flyover/layout";
import BgTransitionLoader from './shared/bgTransitionLoader';
//import Root from "./routes/flyover/root";
import NotFoundPage from './strips/notFoundPage';
console.log("ReactAppRoot", document.getElementById('ReactAppRoot'));
//const Root = lazy(() => import("./routes/root"));
var router = createBrowserRouter([
    {
        element: React.createElement(Suspense, { fallback: React.createElement(BgTransitionLoader, null) },
            React.createElement(Layout, null)),
        errorElement: React.createElement(NotFoundPage, { isFlyoverSite: true }),
        loader: layoutLoader,
        path: "*",
        children: null
        //errorElement: <ErrorPage />,
        // loader: layoutLoader,
        //children: [
        //     {
        //         path: "*",
        //           element: <Suspense fallback={<div>loading</div>}><Root /></Suspense>               
        //        }
        //  ]
    }
]);
//const root = ReactDOM.createRoot(document.getElementById('ReactAppRoot'));
//root.render(<Layout/>)
ReactDOM.createRoot(document.getElementById('ReactAppRoot')).render(React.createElement(Suspense, { fallback: React.createElement(BgTransitionLoader, null) },
    React.createElement(React.StrictMode, null,
        React.createElement(RouterProvider, { router: router }))));
